import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { Button } from './ui/button';

const Header = () => {
  const { getCartCount } = useCart();
  const cartCount = getCartCount();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return null;
  }

  return (
    <header data-testid="main-header" className="fixed top-0 w-full z-50 bg-background/80 backdrop-blur-xl border-b border-border/10 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
            <img 
              src="/assets/logo.png" 
              alt="Estel Regals" 
              className="h-14 md:h-16 w-auto rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300"
            />
          </Link>

          <nav data-testid="main-nav" className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              data-testid="nav-home"
              className="text-sm tracking-widest uppercase text-foreground hover:text-primary transition-colors"
            >
              Inici
            </Link>
            <Link 
              to="/catalog" 
              data-testid="nav-catalog"
              className="text-sm tracking-widest uppercase text-foreground hover:text-primary transition-colors"
            >
              Catàleg
            </Link>
          </nav>

          <Link to="/cart" data-testid="cart-button">
            <Button variant="ghost" size="icon" className="relative">
              <ShoppingCart className="h-5 w-5" />
              {cartCount > 0 && (
                <span data-testid="cart-count" className="absolute -top-1 -right-1 bg-accent text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;